import { TransactionHistoryIcon } from "@/constant/imagePath";
import IconButton from "..";

const TransactionHistoryButton = ({
  icon = TransactionHistoryIcon,
  borderColor = "#7F2F0F",
  fromColor = "#E17649",
  toColor = "#7F2F0F",
  buttonStyle = { padding: "3.7px 4.1px" },
  onClick = null,
  tooltipText = "Transaction History",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default TransactionHistoryButton;
